export default __webpack_public_path__ + "c0efe43221844a9801fba9112fad6920.webp";